import { X, Loader2 } from 'lucide-react';
import { usePdfUpload } from '../hooks/usePdfUpload';
import { UploadDropzone } from './upload/UploadDropzone';
import { UploadImageAnalysisOption } from './upload/UploadImageAnalysisOption';

function UploadModalHeader({ onClose }) {
  return (
    <div className="flex items-center justify-between">
      <h3 className="text-xl font-serif tracking-tight">Uploader un PDF</h3>
      <button
        data-testid="close-upload-modal"
        onClick={onClose}
        className="rounded-sm p-2 transition-colors hover:bg-zinc-900/50"
      >
        <X className="h-5 w-5" />
      </button>
    </div>
  );
}

function UploadModalActions({ selectedFile, uploading, phaseLabel, onCancel, onUpload }) {
  if (!selectedFile) {
    return null;
  }

  return (
    <div className="space-y-3">
      {uploading && phaseLabel ? (
        <p
          data-testid="upload-phase-label"
          className="text-center text-xs uppercase tracking-wider text-zinc-400"
        >
          {phaseLabel}
        </p>
      ) : null}
      <div className="flex gap-3">
        <button
          data-testid="cancel-file-button"
          onClick={onCancel}
          disabled={uploading}
          className="h-12 flex-1 rounded-sm border border-zinc-800 bg-transparent text-white transition-all duration-300 hover:border-white hover:bg-zinc-900/50 disabled:cursor-not-allowed disabled:opacity-50"
        >
          Annuler
        </button>
        <button
          data-testid="upload-file-button"
          onClick={onUpload}
          disabled={uploading}
          className="flex h-12 flex-1 items-center justify-center gap-2 rounded-sm bg-white font-medium text-black transition-all duration-300 hover:bg-zinc-200 disabled:cursor-not-allowed disabled:opacity-50"
        >
          {uploading ? (
            <>
              <Loader2 className="h-5 w-5 animate-spin" />
              <span>Upload...</span>
            </>
          ) : (
            'Uploader'
          )}
        </button>
      </div>
    </div>
  );
}

function UploadModalBody({ uploadState, onClose }) {
  return (
    <div data-testid="upload-modal" className="w-full max-w-md space-y-6 rounded-md border border-border bg-card p-6" onClick={(event) => event.stopPropagation()}>
      <UploadModalHeader onClose={onClose} />
      <UploadDropzone dropzone={uploadState.dropzone} selectedFile={uploadState.selectedFile} />
      <UploadImageAnalysisOption analyzeImages={uploadState.analyzeImages} onToggle={uploadState.setAnalyzeImages} />
      <UploadModalActions
        selectedFile={uploadState.selectedFile}
        uploading={uploadState.uploading}
        phaseLabel={uploadState.phaseLabel}
        onCancel={uploadState.clearSelectedFile}
        onUpload={uploadState.handleUpload}
      />
    </div>
  );
}

export default function UploadModal({ knowledgeBaseId, onClose, onSuccess }) {
  const uploadState = usePdfUpload({ knowledgeBaseId, onSuccess });

  return (
    <div data-testid="upload-modal-overlay" className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 p-4 backdrop-blur-sm" onClick={onClose}>
      <UploadModalBody uploadState={uploadState} onClose={onClose} />
    </div>
  );
}
